var _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOneDoorClosed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25586 2.66992C3.46093 2.66992 2.00586 4.125 2.00586 5.91992V19.4199C2.00586 21.2148 3.46093 22.6699 5.25586 22.6699H18.7559C20.5508 22.6699 22.0059 21.2148 22.0059 19.4199V5.91992C22.0059 4.125 20.5508 2.66992 18.7559 2.66992H5.25586ZM3.50586 5.91992C3.50586 4.95342 4.28936 4.16992 5.25586 4.16992H11.2559L11.2559 21.1699H5.25586C4.28936 21.1699 3.50586 20.3864 3.50586 19.4199V5.91992ZM12.0059 4.16992H18.7559C19.7224 4.16992 20.5059 4.95342 20.5059 5.91992V19.4199C20.5059 20.3864 19.7224 21.1699 18.7559 21.1699H12.0059L12.0059 4.16992Z",
    fill: "#222729"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50586 5.91992C3.50586 4.95342 4.28936 4.16992 5.25586 4.16992H11.2559L11.2559 21.1699H5.25586C4.28936 21.1699 3.50586 20.3864 3.50586 19.4199V5.91992Z",
    fill: "#222729"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.00586,
    y: 10.6699,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOneDoorClosed);
export default __webpack_public_path__ + "static/media/icon-one-door-closed.484aa656c78ac8c9006923206a1da28b.svg";
export { ForwardRef as ReactComponent };